<!--

CONFIGURAÇÃO DE PAGAMENTOS ON LINE

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';
import Button from '../components/button.vue';

export default {
    props: {
        parametros: { type: Object },
    },

    components: {
        Button
    },

    data () {
        return {
            editingShopline: false,
            editingCielo: false,
            editingRede: false,
            editingPixitau: false,
            editingPagseguro: false,
            editingRedeObj: null,
            editingCieloObj: null,
            editingShoplineObj: null,
            editingPixitauObj: null,
            editingPagseguroObj: null,
            showAccordionCielo: false,
            showAccordionRede: false,
            showAccordionShopline: false,
            showAccordionPixItau: false,
            showAccordionPagSeguro: false
        }
    },

    computed: {

    },

    filters: {

    },
    methods: {
        handleAccordion(operadora){
            this.resetAccordionVariables(operadora);
            if(operadora == 'cielo'){
                this.showAccordionCielo = !this.showAccordionCielo;
            }
            if(operadora == 'rede'){
                this.showAccordionRede = !this.showAccordionRede;
            }
            if(operadora == 'shopline'){
                this.showAccordionShopline = !this.showAccordionShopline;
            }
            if(operadora == 'pix-itau'){
                this.showAccordionPixItau = !this.showAccordionPixItau;
            }
            if(operadora == 'pagseguro'){
                this.showAccordionPagSeguro = !this.showAccordionPagSeguro
            }
        },
        resetAccordionVariables(operadora){
            if(operadora == 'cielo'){
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false
            }
            if(operadora == 'rede'){
                this.showAccordionCielo = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false
            }
            if(operadora == 'shopline'){
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionPixItau = false;
                this.showAccordionPagSeguro = false
            }
            if(operadora == 'pix-itau'){
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPagSeguro = false
            }
            if(operadora == 'pagseguro'){
                this.showAccordionCielo = false;
                this.showAccordionRede = false;
                this.showAccordionShopline = false;
                this.showAccordionPixItau = false
            }
        },
        handleDesativar (operadora) {
            if (operadora == 'cielo') {
                this.parametros.pagonline.habilitaCielo = false
                this.parametros.pagonline.habilitaCieloCheckout = false
            }
            if (operadora == 'rede') {
                this.parametros.pagonline.habilitaRede = false
                this.parametros.pagonline.habilitaRedeCheckout = false
            }
            if (operadora == 'shopline') {
                this.parametros.pagonline.habilitaShopline = false
                this.parametros.pagonline.habilitaShoplineCheckout = false
            }
            if (operadora == 'pixitau') {
                this.parametros.pagonline.habilitaPixitau = false
                this.parametros.pagonline.habilitaPixitauCheckout = false
            }
            if (operadora == 'pagseguro') {
                this.parametros.pagonline.habilitaPagseguro = false
                this.parametros.pagonline.habilitaPagseguroCheckout = false
            }
            this.$emit('saveconfig')
        },

        handleAtivar (operadora) {
            if (operadora == 'cielo') {
                this.editingCielo = true
                this.editingCieloObj = {...this.parametros.pagonline.cielo}
            }
            if (operadora == 'shopline') {
                this.editingShopline = true
                if (!this.parametros.pagonline.shopline)
                  this.parametros.pagonline.shopline = { codigosite: '', chave: '', observacaoboleto: null, desconto: null, observacao: null }
                this.editingShoplineObj = {...this.parametros.pagonline.shopline}
            }
            if (operadora == 'rede') {
                this.editingRede = true
                this.editingRedeObj = {...this.parametros.pagonline.rede}
            }
            if (operadora == 'pixitau') {
                this.editingPixitau = true
                if (!this.parametros.pagonline.pixitau)
                  this.parametros.pagonline.pixitau = { clientid: null, clientsecret: null, desconto: null, observacao: null }
                this.editingPixitauObj = {...this.parametros.pagonline.pixitau}
            }
            if (operadora == 'pagseguro') {
                this.editingPagseguro = true
                if (!this.parametros.pagonline.pagseguro)
                  this.parametros.pagonline.pagseguro = { email: '', token: '', desconto: null, observacao: null }
                this.editingPagseguroObj = {...this.parametros.pagonline.pagseguro}
            }
        },

        handleSalvarRede () {
            this.parametros.pagonline.habilitaRede = true
            this.editingRede = false
            this.$emit('saveconfig')
        },

        handleCancelarRede () {
            this.parametros.pagonline.rede = this.editingRedeObj
            this.editingRede = false
            this.$emit('saveconfig')
        },

        handleSalvarPixitau () {
            this.parametros.pagonline.habilitaPixitau = true
            this.editingPixitau = false
            this.$emit('saveconfig')
        },

        handleCancelarPixitau () {
            this.parametros.pagonline.pixitau = this.editingPixitauObj
            this.editingPixitau = false
            this.$emit('saveconfig')
        },

        handleSalvarCielo () {
            this.parametros.pagonline.habilitaCielo = true
            this.editingCielo = false
            this.$emit('saveconfig')
        },

        handleSalvarShopline () {
            this.parametros.pagonline.habilitaShopline = true
            this.editingShopline = false
            this.$emit('saveconfig')
        },

        handleCancelarCielo () {
            this.parametros.pagonline.cielo = this.editingCieloObj
            this.editingCielo = false
            this.$emit('saveconfig')
        },

        handleCancelarShopline () {
            this.parametros.pagonline.shopline = this.editingShoplineObj
            this.editingShopline = false
            this.$emit('saveconfig')
        },

        handleEditCielo () {
            this.editingCieloObj = {...this.parametros.pagonline.cielo}
            this.editingCielo = true
        },

        handleEditPixitau () {
            this.editingPixitauObj = {...this.parametros.pagonline.pixitau}
            this.editingPixitau = true
        },

        handleEditShopline () {
            this.editingShoplineObj = {...this.parametros.pagonline.shopline}
            this.editingShopline = true
        },

        handleEditRede () {
            this.editingRedeObj = {...this.parametros.pagonline.rede}
            this.editingRede = true
        },

        handleEditPagseguro () {
            this.editingPagseguroObj = {...this.parametros.pagonline.pagseguro}
            this.editingPagseguro = true
        },


        handleSalvarPagseguro () {
            this.parametros.pagonline.habilitaPagseguro = true
            this.editingPagseguro = false
            this.$emit('saveconfig')
        },

        handleCancelarPagseguro () {
            this.parametros.pagonline.pagseguro = this.editingPagseguroObj
            this.editingPagseguro = false
            this.$emit('saveconfig')
        },

    },

    watch: {

    },

    mounted () {

    },

    created () {
        this.parametros.pagonline.habilitaShopline = false
    }

}

</script>

<template>
  <div>
    <span class="lbl-deal-title mb-3">Operadoras de Pagamento On-Line</span>
    <div class="row mb-2">
        <div class="col">
            <span>Configure as operadoras de pagamento on-line da sua loja!</span>
        </div>
    </div>
    <div class="border p-3 mb-2 cursor-pointer container-accordion" :class="showAccordionCielo ? 'container-open' : 'container-close'">
        <!-- Cielo -->
        <div class="row mb-2 d-flex justify-content-between" @click="handleAccordion('cielo')">
            <div class="col-11">
                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/cielo.png" style="height: 30px">
                <span class="badge badge-success" v-if="parametros.pagonline.habilitaCielo">Ativado</span>
            </div>
            <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showAccordionCielo ? 'up' : 'down')"></i>
            </button>
        </div>
        <div class="row" v-if="!parametros.pagonline.habilitaCielo && !editingCielo">
            <div class="col-md-12">
                <label class="lbl-edit">
                    Habilitar pagamentos através da operadora Cielo
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('cielo')"></v-button>
            </div>
        </div>
        <div 
            class="row mt-3 accordion" 
            id="accordion" 
            v-if="parametros.pagonline.habilitaCielo || editingCielo"
            :class="showAccordionCielo ? '' : 'close'"
        >
        
            <div class="col-md-12 mb-2">
                <label class="lbl-edit">
                    <input type="checkbox" v-model="parametros.pagonline.habilitaCieloCheckout" :disabled="!editingCielo"> Permitir que o comprador efetue o pagamento no fechamento da venda
                </label>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Client Id"></v-label>
                <form-field key="cieloclientid" v-model="parametros.pagonline.cielo.clientid" type="text" case="normal" :disabled="!editingCielo"
                    data-toggle="tooltip" data-placement="top" title="client Id para acesso ao Cielo API."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Client Secret"></v-label>
                <form-field ref="cieloclientsecret" v-model="parametros.pagonline.cielo.clientsecret" type="text" case="normal" :disabled="!editingCielo"
                    data-toggle="tooltip" data-placement="top" title="Client Secret para acesso ao Cielo API."></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Desconto"></v-label>
                <form-field ref="cielodesconto" v-model="parametros.pagonline.cielo.desconto" type="number" :precion="2" addon="%" case="normal" :disabled="!editingCielo"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar um % de desconto para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Observações"></v-label>
                <form-field v-model="parametros.pagonline.cielo.observacao" type="text" case="normal" :disabled="!editingCielo"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar uma Observação para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-12 mt-2" v-if="!editingCielo">
                <v-label label="Seu link de Notificação Cielo (Super Link)"></v-label>
                <div class="w-100"></div>
                <span class="badge badge-secondary">https://novo.notabrasil.com.br/ords/apiloja/notificacaopagamento/{{ parametros.codempresa }}</span>
            </div>
            <div class="col-md-12 mt-3" v-if="editingCielo">
                <v-button label="Salvar" :success="true" @click="handleSalvarCielo"></v-button>
                <v-button label="Cancelar" @click="handleCancelarCielo"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.pagonline.habilitaCielo && !editingCielo">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('cielo')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditCielo"></v-button>
            </div>
        </div>
    </div>

    <div class="border p-3 mb-2 cursor-pointer container-accordion" :class="showAccordionRede ? 'container-open' : 'container-close'">
        <!-- Rede -->
        <div class="row mb-2" @click="handleAccordion('rede')">
            <div class="col-11">
                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/rede.png" style="height: 30px">
                <span class="badge badge-success" v-if="parametros.pagonline.habilitaRede">Ativado</span>
            </div>
            <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showAccordionRede ? 'up' : 'down')"></i>
            </button>
        </div>
        <div class="row" v-if="!parametros.pagonline.habilitaRede && !editingRede">
            <div class="col-md-12">
                <label class="lbl-edit">
                    Habilitar pagamentos através da operadora Rede
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('rede')"></v-button>
            </div>
        </div>
        <div 
            class="row mt-3 accordion" 
            v-if="parametros.pagonline.habilitaRede || editingRede"
            :class="showAccordionRede ? '' : 'close'"
        >
            <div class="col-md-12 mb-2">
                <label class="lbl-edit">
                    <input type="checkbox" v-model="parametros.pagonline.habilitaRedeCheckout" :disabled="!editingRede"> Permitir que o comprador efetue o pagamento no fechamento da venda
                </label>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Token"></v-label>
                <form-field key="redetoken" v-model="parametros.pagonline.rede.token" type="text" case="normal" :disabled="!editingRede"
                data-toggle="tooltip" data-placement="top" title="token para acesso a REDE API."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="PV"></v-label>
                <form-field ref="redepv" v-model="parametros.pagonline.rede.pv" type="text" case="normal" :disabled="!editingRede"
                data-toggle="tooltip" data-placement="top" title="PV para acesso a REDE API."></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Desconto"></v-label>
                <form-field v-model="parametros.pagonline.rede.desconto" type="number" :precion="2" addon="%" :disabled="!editingRede"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar um % de desconto para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Parcelas"></v-label>
                <form-field v-model="parametros.pagonline.rede.parcelas" type="number" :precion="0" :disabled="!editingRede"
                    data-toggle="tooltip" data-placement="top" title="Informe o número de parcelas permitida (máximo 12)."></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Valor Mínimo da Parcela"></v-label>
                <form-field v-model="parametros.pagonline.rede.valorMinimoParcela" type="number" :precion="0" :disabled="!editingRede"
                    data-toggle="tooltip" data-placement="top" title="Informe o valor mínimo da parcela."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Observações"></v-label>
                <form-field v-model="parametros.pagonline.rede.observacao" type="text" case="normal" :disabled="!editingRede"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar uma Observação para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-12 mt-3" v-if="editingRede">
                <v-button label="Salvar" :success="true" @click="handleSalvarRede"></v-button>
                <v-button label="Cancelar" @click="handleCancelarRede"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.pagonline.habilitaRede && !editingRede">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('rede')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditRede"></v-button>
            </div>
        </div>
    </div>

    <div class="border p-3 mb-2 cursor-pointer container-accordion" :class="showAccordionShopline ? 'container-open' : 'container-close'">
        <!-- shopline -->
        <div class="row mb-2" @click="handleAccordion('shopline')">
            <div class="col-11">
                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/itau_shopline.png" style="height: 60px">
                <span class="badge badge-success" v-if="parametros.pagonline.habilitaShopline">Ativado</span>
            </div>
            <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showAccordionShopline ? 'up' : 'down')"></i>
            </button>
        </div>
        <div 
            class="row accordion" 
            v-if="!parametros.pagonline.habilitaShopline && !editingShopline"
            :class="showAccordionShopline ? '' : 'close'"
        >
            <div class="col-md-12">
                <label class="lbl-edit">
                    Habilitar pagamentos através da operadora Itau Shopline através de boleto ou transferência eletrônica
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('shopline')"></v-button>
            </div>
        </div>
        <div class="row mt-3" v-if="parametros.pagonline.habilitaShopline || editingShopline">
            <div class="col-md-6 col-12">
                <v-label label="Site"></v-label>
                <form-field key="shoplinesite" v-model="parametros.pagonline.shopline.codigosite" type="text" case="normal" :disabled="!editingShopline"
                    data-toggle="tooltip" data-placement="top" title="Código da empresa no itaú shopline"
                    v-validate="{min: 26, max: 26}"></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Chave de criptografia"></v-label>
                <form-field ref="shoplinechave" v-model="parametros.pagonline.shopline.chave" type="text" case="normal" :disabled="!editingShopline"
                    data-toggle="tooltip" data-placement="top" title="Chave da criptografia"
                    v-validate="{min: 16, max: 16}"></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Desconto"></v-label>
                <form-field v-model="parametros.pagonline.shopline.desconto" type="number" :precion="2" addon="%" case="normal" :disabled="!editingShopline"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar um % de desconto para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Observações"></v-label>
                <form-field v-model="parametros.pagonline.shopline.observacao" type="text" case="normal" :disabled="!editingShopline"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar uma Observação para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-12 mt-2" v-if="!editingShopline">
                <v-label label="Campo URL de retorno"></v-label>
                <div class="w-100"></div>
                <span class=""><strong>dominio.notabrasil.com.br/notificacaopagamento</strong></span>
            </div>
            <div class="col-md-12 mt-3" v-if="editingShopline">
                <v-button label="Salvar" :success="true" @click="handleSalvarShopline"></v-button>
                <v-button label="Cancelar" @click="handleCancelarShopline"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.pagonline.habilitaShopline && !editingShopline">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('shopline')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditShopline"></v-button>
            </div>
        </div>
    </div>

    <div class="border p-3 mb-2 cursor-pointer container-accordion" :class="showAccordionPixItau ? 'container-open' : 'container-close'">
        <!-- pix itau -->
        <div class="row mb-2" @click="handleAccordion('pix-itau')">
            <div class="col-11">
                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/pixitau.png" style="height: 50px">
                <span class="badge badge-success" v-if="parametros.pagonline.habilitaPixitau">Ativado</span>
            </div>
            <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showAccordionPixItau ? 'up' : 'down')"></i>
            </button>
        </div>
        <div 
            class="row" 
            v-if="!parametros.pagonline.habilitaPixitau && !editingPixitau"
            
        >
            <div class="col-md-12">
                <label class="lbl-edit">
                    Habilitar pagamentos online por PIX através do banco Itau
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('pixitau')"></v-button>
            </div>
        </div>
        <div 
            class="row mt-3 accordion" 
            v-if="parametros.pagonline.habilitaPixitau || editingPixitau"
            :class="showAccordionPixItau ? '' : 'close'"
            >
            <div class="col-md-12 mb-2">
                <label class="lbl-edit">
                    <input type="checkbox" v-model="parametros.pagonline.habilitaPixitauCheckout" :disabled="!editingPixitau"> Permitir que o comprador efetue o pagamento no fechamento da venda
                </label>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Client Id"></v-label>
                <form-field key="pixitauclientid" v-model="parametros.pagonline.pixitau.clientid" type="text" case="normal" :disabled="!editingPixitau"
                    data-toggle="tooltip" data-placement="top" title="client Id para acesso à sua conta do itau."></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Client Secret"></v-label>
                <form-field ref="pixitauclientsecret" v-model="parametros.pagonline.pixitau.clientsecret" type="text" case="normal" :disabled="!editingPixitau"
                    data-toggle="tooltip" data-placement="top" title="Client Secret para acesso à sua conta do itau."></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Desconto"></v-label>
                <form-field ref="pixitaudesconto" v-model="parametros.pagonline.pixitau.desconto" type="number" :precion="2" addon="%" case="normal" :disabled="!editingPixitau"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar um % de desconto para esta forma de pagamento."></form-field>
            </div>
             <div class="col-md-6 col-12">
                <v-label label="Observações"></v-label>
                <form-field v-model="parametros.pagonline.pixitau.observacao" type="text" case="normal" :disabled="!editingPixitau"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar uma Observação para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-12 mt-3" v-if="editingPixitau">
                <v-button label="Salvar" :success="true" @click="handleSalvarPixitau"></v-button>
                <v-button label="Cancelar" @click="handleCancelarPixitau"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.pagonline.habilitaPixitau && !editingPixitau">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('pixitau')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditPixitau"></v-button>
            </div>
        </div>
    </div>

    <div class="border p-3 mb-2 cursor-pointer container-accordion" :class="showAccordionPagSeguro ? 'container-open' : 'container-close'" >
        <!-- pagseguro -->
        <div class="row mb-2">
            <div class="col-11" @click="handleAccordion('pagseguro')">
                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/formaspagamento/pagseguro.png" style="height: 60px">
                <span class="badge badge-success" v-if="parametros.pagonline.habilitaPagseguro">Ativado</span>
            </div>
            <button class=" col-1 border-0 bg-transparent" style="outline: none">
                <i :class="'text-secondary fa fa-chevron-' + (showAccordionPagSeguro ? 'up' : 'down')"></i>
            </button>
        </div>
        <div class="row" v-if="!parametros.pagonline.habilitaPagseguro && !editingPagseguro">
            <div class="col-md-12">
                <label class="lbl-edit">
                    Habilitar pagamentos através da operadora Pagseguro através de boleto ou cartões débitos/crédito
                </label>
            </div>
            <div class="col-md-12">
                <v-button label="Ativar" :success="true" @click="handleAtivar('pagseguro')"></v-button>
            </div>
        </div>
        <div 
            class="row mt-3 accordion" 
            v-if="parametros.pagonline.habilitaPagseguro || editingPagseguro"
            :class="showAccordionPagSeguro ? '' : 'close'"
        >
            <div class="col-md-12 mb-2">
                <label class="lbl-edit">
                    <input type="checkbox" v-model="parametros.pagonline.habilitaPagseguroCheckout" :disabled="!editingPagseguro"> Permitir que o comprador efetue o pagamento no fechamento da venda
                </label>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="E-mail"></v-label>
                <form-field key="pagseguroemail" v-model="parametros.pagonline.pagseguro.email" type="email" case="normal" :disabled="!editingPagseguro"
                    data-toggle="tooltip" data-placement="top" title="E-mail no PagSeguro"
                    v-validate=""></form-field>
            </div>
            <div class="col-md-6 col-12">
                <v-label label="Token"></v-label>
                <form-field ref="pagsegurotoken" v-model="parametros.pagonline.pagseguro.token" type="text" case="normal" :disabled="!editingPagseguro"
                    data-toggle="tooltip" data-placement="top" title="Token no PagSeguro"
                    v-validate=""></form-field>
            </div>
            <div class="col-md-2 col-12">
                <v-label label="Desconto"></v-label>
                <form-field v-model="parametros.pagonline.pagseguro.desconto" type="number" :precion="2" addon="%" case="normal" :disabled="!editingPagseguro"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar um % de desconto para esta forma de pagamento."></form-field>
            </div>
             <div class="col-md-6 col-12">
                <v-label label="Observações"></v-label>
                <form-field v-model="parametros.pagonline.pagseguro.observacao" type="text" case="normal" :disabled="!editingPagseguro"
                    data-toggle="tooltip" data-placement="top" title="Você pode informar uma Observação para esta forma de pagamento."></form-field>
            </div>
            <div class="col-md-12 mt-3" v-if="editingPagseguro">
                <v-button label="Salvar" :success="true" @click="handleSalvarPagseguro"></v-button>
                <v-button label="Cancelar" @click="handleCancelarPagseguro"></v-button>
            </div>
            <div class="col-md-12 mt-3" v-if="parametros.pagonline.habilitaPagseguro && !editingPagseguro">
                <v-button label="Desativar" :danger="true" @click="handleDesativar('pagseguro')"></v-button>
                <v-button icon="fa-pencil" label="Editar" @click="handleEditPagseguro"></v-button>
            </div>
        </div>
    </div>
    <hr>
  </div>

</template>

<style scoped>

.container-accordion{
    transition: all .4s ease-in-out;
    position: relative;
    overflow-y: hidden;
}
.container-open{
    max-height: 900px;
}
div::-webkit-scrollbar {
    display: none;
    width: 0;
}
div::-webkit-scrollbar-track{
    background: transparent;
}
.container-close{
    overflow-y: hidden;
    max-height: 80px;
}
.accordion{
    transition: opacity .4s linear ;
    transition-delay: .3s;
}
.open{
    opacity: 100%;
}
.close{
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/forms-loja/config-pagonline-form-loja.vue